// The entry's first import: B.C. times right on a browser whose zone data predates tzdata 2026b
// (QA-791). It must run before anything builds a formatter; on an up-to-date browser it does nothing.
import { installZoneFix } from '@flowology/kernel';

installZoneFix();
